'use es6';

import * as api from 'laboratory-lib/core/api';
import { validateTreatmentOrKeys } from 'laboratory-lib/core/validators';
import { resolveExposures } from 'laboratory-lib/core/utils';
export function createExposureLogger(_ref) {
  var apiDomain = _ref.apiDomain,
      http = _ref.http,
      resolveTreatments = _ref.resolveTreatments,
      onError = _ref.onError;

  var logExposures = function logExposures() {
    var treatmentOrKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    try {
      validateTreatmentOrKeys(treatmentOrKeys, 'treatmentsClient.logExposure(s)');
      resolveTreatments(function (treatments) {
        var exposures = resolveExposures({
          treatments: treatments,
          treatmentOrKeys: treatmentOrKeys
        });

        if (exposures.length) {
          api.logExposures({
            apiDomain: apiDomain,
            exposures: exposures,
            http: http,
            onError: onError
          });
        }
      });
    } catch (err) {
      if (typeof onError === 'function') {
        onError(err);
      }
    }
  };

  return {
    logExposures: logExposures,
    logExposure: function logExposure(treatmentOrKey) {
      return logExposures([treatmentOrKey]);
    }
  };
}